import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface DeliveryOrdersToggleProps {
    showDeliveryOrders: boolean;
    onToggle: (value: boolean) => void;
    deliveryCount: number;
}

export function DeliveryOrdersToggle({
    showDeliveryOrders,
    onToggle,
    deliveryCount
}: DeliveryOrdersToggleProps) {
    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            onToggle(!showDeliveryOrders);
        }
    };

    return (
        <div
            className="flex items-center gap-3 h-12 px-4 border border-border rounded-md bg-background hover:bg-muted transition-colors duration-200"
            role="group"
            aria-label="Delivery orders filter toggle"
        >
            <Switch
                id="delivery-orders-toggle"
                checked={showDeliveryOrders}
                onCheckedChange={onToggle}
                onKeyDown={handleKeyDown}
                aria-label={showDeliveryOrders
                    ? `Hide delivery orders. ${deliveryCount} delivery orders shown.`
                    : 'Show delivery orders. Delivery orders are currently hidden.'}
                className="data-[state=checked]:bg-status-success"
            />
            <Label
                htmlFor="delivery-orders-toggle"
                className="flex h-full flex-1 cursor-pointer select-none items-center gap-2 text-sm font-medium text-foreground"
            >
                <span>
                    Delivery
                </span>
                {/* While the toggle is off the query excludes delivery rows, so a
                    count here would always read "(0)" and imply there are none. */}
                {showDeliveryOrders && (
                    <span className="text-xs font-normal text-muted-foreground tabular-nums">
                        ({deliveryCount})
                    </span>
                )}
            </Label>
        </div>
    );
}
